<template>
  <v-form ref="form" @submit.prevent="onSubmit">
    <v-btn id="closeBtn" icon @click="closeHandler"><v-icon color="black">close</v-icon></v-btn>
    <v-card id="pin-card" flat tile class="pa-4">
      <v-row justify="center" align="center" class="fill-height" no-gutters>
        <v-card-title class="pt-0">
          <div class="text-center">
            <h5 class="headline font-weight-bold">Вход в систему</h5>
            <p class="subtitle-1 grey--text text--darken-2">Введите пин-код</p>
          </div>
        </v-card-title>
        <v-card-text class="text-center">
          <v-text-field
            solo
            flat
            type="password"
            name="pin"
            autofocus
            hide-details
            v-mask="'####'"
            ref="input"
            v-model="pin"
          />
        </v-card-text>
        <v-card-actions class="px-4 pt-8">
          <v-spacer />
          <v-btn
            name="pinBtn"
            large
            :disabled="isDisabled"
            :loading="checkPinLoading"
            rounded
            type="submit"
            color="primary"
            class="px-8"
          >
            <span class="pl-2">Войти</span>
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-row>
    </v-card>
  </v-form>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
  name: 'Pin',
  directives: { mask },
  data: () => ({
    pin: '',
    isDisabled: true
  }),
  watch: {
    pin(val) {
      this.isDisabled = val && val.length !== 4
    }
  },
  computed: {
    checkPinLoading() {
      return this.$store.state.auth.loading.checkPin
    }
  },
  methods: {
    onSubmit() {
      this.$store.dispatch('CHECK_PIN_CODE', this.pin)
    },
    closeHandler() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.v-form {
  position: relative;
  #closeBtn {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 10;
  }
}
#pin-card {
  height: 450px;
  border-radius: 8px;
}
.v-text-field {
  width: 180px;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
  font-size: 80px;
  padding-left: 16px;
}
</style>
